export const BASE_PAGE = '/'
export const SEARCH_PAGE = '/search'
export const PROFILE_PAGE = '/profile'
export const PIPELINE_PAGE = '/pipeline'
export const GIFT_PAGE = '/gift'
export const CONTACT_PAGE = '/contact'
export const LOGIN = '/login'
export const RESET_PASSWORD = '/reset-password'
export const USER_PROFILE = '/user-profile'
export const OAUTH_AUTHORIZE = '/oauth-authorize'
